import { Component} from '@angular/core';
import {DialogAdapter, DialogParams, DialogResult} from '../../models/dialog-param';
import {Subscription} from 'rxjs/Rx';
import {SharedValueService} from '../../services/shared-value.service';
import {Helper} from '../../common/helper';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BUTTON_NAME, EMAIL_REGEX} from '../../common/constants';

@Component({
  selector: 'app-modal-change-password',
  templateUrl: './modal-change-password.component.html',
  styleUrls: ['./modal-change-password.component.scss'],
  preserveWhitespaces: false
})
export class ModalChangePasswordComponent implements DialogAdapter {
  params: DialogParams;
  prop: any;
  formGroup: FormGroup;
  subscription: Subscription;
  isInitial = true;
  errorMsg = {
    password: '',
    confirm_password: ''
  };
  messageError: any;

  constructor(private sharedValueService: SharedValueService,
              private helper: Helper,
              private fb: FormBuilder) {
    this.helper._unsubsribe(this.subscription);
    this.subscription = sharedValueService.getHttpStatus().subscribe(status => {
      if (status) {
        if (this.prop && this.prop.hasOwnProperty('isAPICallError')) {
          this.prop.isAPICallError = false;
        }
        this.formGroup.reset();
        this.params.subject.complete();
        setTimeout(() => {
          (<any>$('#theModal')).modal('hide');
          this.isInitial = true;
          this.helper._unsubsribe(this.subscription);
        });
      } else {
        if (this.prop) {
          this.prop.isAPICallError = true;
          this.prop.checkValidate = true;
        }
      }
    });
  }

  onModalInit() {
    this.prop = this.params.extraParams.initialValue;
    if (this.isInitial) {
      this.formGroup = this.createForm(this.prop);

      this.messageError = this.getValidationMessages();

      this.isInitial = false;
    } else {
      if (this.checkValidate()) {
        this.prop.checkValidate = false;
        this.params.subject.next(new DialogResult(BUTTON_NAME.OK, this.getPayload()));
      } else {
        this.prop.checkValidate = true;
      }
    }
  }

  createForm(data) {
    const form = this.fb.group({
      'password': [
        data.password, Validators.compose([Validators.required, Validators.minLength(6)])
      ],
      'confirm_password': [
        data.confirm_password, Validators.required
      ]
    });

    return form;
  }

  checkValidate() {
    let passIsMatch = true ;
    for (const field in this.errorMsg) {
      this.errorMsg[field] = '';
      const control = this.formGroup.get(field);
      if (field === 'confirm_password' && control && control.value !== this.formGroup.get('password').value) {
        this.errorMsg[field] = this.messageError[field].pattern;
        passIsMatch = false;
      }
      if (control && control.invalid) {
        for (const key in control.errors) {
          const mess = this.messageError[field];
          if (control.errors.hasOwnProperty(key)) {
            this.errorMsg[field] = mess[key];
          }
        }
      }
    }
    return this.formGroup.valid && passIsMatch;
  }

  getValidationMessages() {
    return {
      'password': {
        'required': 'Password is required.',
        'minlength': 'Passwords must be at least 6 characters in length.'
      },
      'confirm_password': {
        'required': 'The confirm password is required',
        'pattern': 'Passwords do not match.'
      }
    };
  }


  getPayload() {
    return {
      isAPICallError: this.prop.isAPICallError,
      checkValidate: this.prop.checkValidate,
      model: this.formGroup.value
    };
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/modal-change-password/modal-change-password.component.ts